import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import './ThemeToggle.scss';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="theme-toggle__track">
        <div className="theme-toggle__thumb">
          {theme === 'light' ? (
            <Sun size={16} className="theme-toggle__icon" />
          ) : (
            <Moon size={16} className="theme-toggle__icon" />
          )}
        </div>
      </div>
      <span className="theme-toggle__label">
        {theme === 'light' ? 'Light' : 'Dark'} Mode
      </span>
    </button>
  );
};

export default ThemeToggle;
